<style>
.custom_bgColor {
  background-color: white;
}

#inspire {
  background: #f2f2f2 !important;
}

.top-left-dialog____ {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 72px !important;
  margin-left: 10px !important;
  width: auto !important;
}

.dialog-top-left_____-enter-active,
.dialog-top-left_____-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.dialog-top-left_____-enter,
.dialog-top-left_____-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* ── Tablet mega menu dialog: compact centered panel ── */
.tablet-nav-dialog__ .v-card {
  border-radius: 16px !important;
  overflow: hidden;
}

/* ── Mobile mega menu dialog: partial-width drawer pinned to the left edge —
   NOT a fullscreen sheet, so the dimmed backdrop stays visible on the right
   and it reads as a menu opening, not a new page. */
.mobile-nav-dialog__ {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  margin: 0 !important;
  height: auto !important;
  max-height: none !important;
  width: min(320px, 84vw) !important;
  max-width: 84vw !important;
  border-radius: 0 !important;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.18) !important;
}

.mobile-nav-dialog__ .v-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 0 !important;
}

/* The hamburger that opens this menu lives on the left of the top bar, so
   the panel should slide in from the left (left-to-right), not bottom-up —
   Vuetify's dialog-bottom-transition is vertical and slide-x-transition is
   too subtle a nudge for a fullscreen panel, so this is a custom transition. */
.mobile-nav-slide__-enter-active,
.mobile-nav-slide__-leave-active {
  transition: transform 0.28s cubic-bezier(.22, 1, .36, 1), opacity 0.2s ease;
}

.mobile-nav-slide__-enter,
.mobile-nav-slide__-leave-to {
  transform: translateX(-100%);
  opacity: 0.6;
}

/* The mobile/tablet top bars force their own app-bar to z-index:500 while
   menu_dialog is open (.app_z_index, tuned for the old small anchored
   dropdown so its hamburger stayed clickable to close it). These new
   tablet/mobile mega menus are full dialogs with their own close affordance,
   so they need to render above that app-bar, not behind it — otherwise the
   real top bar visually covers the dialog's own header. */
.v-dialog__content:has(>.tablet-nav-dialog__),
.v-dialog__content:has(>.mobile-nav-dialog__) {
  z-index: 600 !important;
}
</style>
<template>
  <section>

    <v-app id="inspire" v-if="domain != 'admin'">
      <TopNavBar ref="top_nav_bar" :is_board_page="is__board_page" :is__adani_page="is__adani_page"
        :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
        :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :is__family_page="is__family_page"
        @to_open_MenuDialog="to_open_MenuDialog" :show_hide_mob_btn="show_hide_mob_btn" :entity__Data="entity__Data"
        @Switch_Entities="Switch_Entities" :menu_dialog="menu_dialog"
        :hide_navigation="isHideNavigation" />

      <TrialBanner v-if="$route.name !== 'PaymentRequired'" />

      <v-main class="custom_bgColor" v-if="entity_ID || domain === 'partner'">
        <router-view :key="$route.matched[0] && $route.matched[0].path"></router-view>
      </v-main>

      <NavSideBar v-if="!isHideNavigation" ref="side_bar" :is_board_page="is__board_page" :is__adani_page="is__adani_page"
        :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
        :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :is__family_page="is__family_page"
        :show_hide_mob_btn="show_hide_mob_btn" :menu_dialog="menu_dialog" @to_close_MenuDialog="to_close_MenuDialog" />

      <!-- Desktop mega menu — unchanged -->
      <v-dialog v-if="!isHideNavigation && navDevice === 'desktop'" v-model="menu_dialog" class="menu_list_dailog"
        content-class="top-left-dialog____" transition="dialog-top-left_____" style="width: auto !important;">
        <v-card style="max-height: calc(100vh - 80px); overflow-y: auto;">
          <CardMenuList :is_board_page="is__board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
            :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
            :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :is__family_page="is__family_page"
            @to_close_MenuDialog="to_close_MenuDialog" />
        </v-card>
      </v-dialog>

      <!-- Tablet mega menu — compact two-panel category + content layout -->
      <v-dialog v-else-if="!isHideNavigation && navDevice === 'tablet'" v-model="menu_dialog" content-class="tablet-nav-dialog__"
        max-width="720">
        <v-card>
          <MegaMenuTablet :is_board_page="is__board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
            :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
            :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :is__family_page="is__family_page"
            :menu-dialog="menu_dialog" @to_close_MenuDialog="to_close_MenuDialog" />
        </v-card>
      </v-dialog>

      <!-- Mobile mega menu — partial-width drawer, accordion navigation -->
      <v-dialog v-else-if="!isHideNavigation" v-model="menu_dialog" content-class="mobile-nav-dialog__"
        transition="mobile-nav-slide__">
        <v-card>
          <MegaMenuMobile :is_board_page="is__board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
            :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
            :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :is__family_page="is__family_page"
            :menu-dialog="menu_dialog" @to_close_MenuDialog="to_close_MenuDialog" />
        </v-card>
      </v-dialog>

      <OldHomeFunctions ref="old_hm_fn" @entity___Data_fn="entity___Data_fn" @entity__id_fn="entity__id_fn" />

      <!-- HIDDEN (temporarily disabled for this release) —
           Floating bottom-right setup progress pill.
           Re-enable by uncommenting the line below when the setup guide is ready for users. -->
      <!-- <SetupProgressBar /> -->
    </v-app>
    <template v-else>
      <Home />
    </template>


  </section>
</template>
<script>
import Home from "@/components/Home.vue";
import TopNavBar from "@/components/Menu/TopNavBar.vue";
import NavSideBar from "@/components/Menu/NavSideBar.vue";
import CardMenuList from "@/components/Menu/CardMenuList.vue";
import MegaMenuTablet from "@/components/Menu/MegaMenu/MegaMenuTablet.vue";
import MegaMenuMobile from "@/components/Menu/MegaMenu/MegaMenuMobile.vue";

import OldHomeFunctions from "@/components/Menu/OldHomeFunctions.vue";
import SetupProgressBar from "@/components/Menu/SetupProgressBar.vue";
import TrialBanner from "@/components/TrialBanner.vue";


export default {
  name: 'HomeNew',
  components: {
    TopNavBar,
    NavSideBar,
    CardMenuList,
    MegaMenuTablet,
    MegaMenuMobile,
    OldHomeFunctions,
    Home,
    SetupProgressBar,
    TrialBanner,
  },
  computed: {
    isHideNavigation() {
      return !!this.$route.meta?.hideNavigation;
    },
    // Mirrors TopNavBar.vue's own navDevice computed so the mega menu dialog
    // uses the same device tier as the top bar it's triggered from.
    navDevice() {
      const w = this.$vuetify.breakpoint.width;
      if (w < 960) return 'mobile';
      if (w < 1264) return 'tablet';
      return 'desktop';
    },
  },
  watch: {
    '$route.path'(newPath) {
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";
      this.is__family_page = isFamilyBook || newPath.includes('/familymenu') || newPath.includes('/familybook') || newPath.includes('/family');
      console.log('HomeNew: Route changed to:', newPath, 'is__family_page:', this.is__family_page, 'isFamilyBook:', isFamilyBook);
    }
  },
  data() {
    return {
      node_env: process.env.NODE_ENV.toLowerCase().trim(),
      drawer: true,
      menu_dialog: false,
      window: {
        width: 0,
        height: 0,
      },
      show_hide_mob_btn: 0,
      entity__Data: [],
      entity_ID: null,
      domain: localStorage.getItem("domain"),

      is__adani_page: localStorage.getItem("domain") === 'adani' ? true : false,
      is__gmr_page: localStorage.getItem("domain") === 'gmr' ? true : false,
      is__board_page: window.location.hostname.includes('myboardpage') ? true : false,
      is__vardhman_page: localStorage.getItem("domain") === 'vardhman' ? true : false,
      is__parle_page: localStorage.getItem("domain") === 'parle' ? true : false,
      is__granules_page: localStorage.getItem("domain") === 'granules' ? true : false,
      is__emami_page: localStorage.getItem("domain") === 'emami' ? true : false,
      is__family_page: (localStorage.getItem("is_family_book") === "true") || window.location.pathname.includes('/familymenu') || window.location.pathname.includes('/familybook') || window.location.pathname.includes('/FamilyDashboard') ? true : false,
    }
  },
  created() {
    window.addEventListener("resize", this.handleMobile);
    this.handleMobile();
    console.log('HomeNew created:', {
      is__family_page: this.is__family_page,
      isFamilyBook: localStorage.getItem("is_family_book"),
      current_path: window.location.pathname
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleMobile);
  },
  methods: {
    handleMobile() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 576) {
        this.show_hide_mob_btn = 2;
      } else {
        this.show_hide_mob_btn = 1;
      }
    },
    to_open_MenuDialog() {
      this.menu_dialog = !this.menu_dialog;
    },
    to_close_MenuDialog() {
      this.menu_dialog = false;
    },
    Switch_Entities() {
      this.$refs.old_hm_fn.switch_entity();
    },
    entity___Data_fn(entity__Data) {
      this.entity__Data = entity__Data;
    },
    entity__id_fn(entity_ID) {
      this.entity_ID = entity_ID;
    },
  },
}
</script>
